import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import type { SoilAnalysisDTO } from './types';

interface UseGetSoilAnalysisByIdOptions<TData> {
	enabled?: boolean;
	select?: (data: SoilAnalysisDTO) => TData;
}

export const useGetSoilAnalysisById = <TData = SoilAnalysisDTO>(
	id?: string,
	options?: UseGetSoilAnalysisByIdOptions<TData>
) => {
	const forBinding = useForBindingId();
	return useQuery({
		queryKey: ['soilAnalysisId', id, forBinding],
		enabled: (options?.enabled ?? true) && !!id,
		queryFn: async () => {
			const { data } = await api.get<SoilAnalysisDTO>(`/soil-analysis/get/${id}`, {
				params: { forBinding },
			});
			return data;
		},
		select: options?.select,
	});
};
